
// ==============================================

//        INTERFACE FUNCTIONS

// ==============================================

document.addEventListener('DOMContentLoaded', function(e) {


  //        Share buttons
  // ==============================================
  $('.btn-share[data-type]').click(function(e){
    e.preventDefault();

    var type         = $(this).data('type'),
       url           = encodeURIComponent($('meta[property="og:url"]').attr('content')),
       title         = encodeURIComponent($('meta[property="og:title"]').attr('content')),
       description   = encodeURIComponent($('meta[property="og:description"]').attr('content')),
       image         = $('meta[property="og:image"]').attr('content'),
       twitter_title = encodeURIComponent($('meta[name="twitter:title"]').attr('content')),
       // shortlink     = encodeURIComponent($('link[rel="shortlink"]').attr('href')),
       hash_tags     = '',
       u             = '';

       // ∆∆∆∆∆ tester ∆∆∆∆∆∆∆∆∆∆∆∆∆∆∆∆
       // url           = encodeURIComponent('http://blog.chargemap.com/5-chargemap-features-absolutely-know/');
       // url           = encodeURIComponent('https://chargemap-blog-prod.osc-fr1.scalingo.io/de/coronavirus-worauf-sollten-sie-bei-ihrem-stillgelegten-elektroauto-achten/');
       // ∆∆∆∆∆∆∆∆∆∆∆∆∆∆∆∆∆∆∆∆∆∆∆∆∆∆∆∆∆

     switch (type) {
       case 'facebook':
         u = `http://www.facebook.com/sharer/sharer.php?u=${url}`;
         break;

       case 'twitter':
         u   = `https://twitter.com/intent/tweet/?url=${url}&text=${twitter_title}`;
         break;

       case 'pinterest':
         u = `https://www.pinterest.com/pin/create/button/?url=${url}&description=${title}&hashtags=${hash_tags}`;
         break;

       case 'linkedin':
         u = `https://www.linkedin.com/shareArticle?mini=true&url=${url}`;
         break;

       case 'googleplus':
         u = `https://plus.google.com/share?url=${url}`;
         break;

       default:
         console.log('Sorry, we are out of ' + type + '.');
         return;
     }

      centerPopup(u, 600, 450);
    });


    function centerPopup(url, width, height) {
      var screenLeft = window.screenLeft || window.screenX,
          screenTop  = window.screenTop || window.screenY,
          left       = screenLeft + ($(window).width() - width) / 2,
          top        = screenTop + ($(window).height() - height) / 2;
      var params     = `menubar=no,toolbar=no,resizable=yes,width=${width},height=${height},top=${top},left=${left}`;
      window.open(url, '', params);
    }

})
